<template>
    <section class="home-section home-hero">
        <img
            :src="logoImage('powered-by-white.png')"
            alt="powered by Structure SDK logo"
        />
    </section>

    <section class="home-section home-section-1">
    <div class="home-sec1-header">
        <h1>The world's most advanced spatial computing platform.</h1>
        <p>Structure SDK, the world’s most powerful mobile 3D scanning platform, now supports XRPro's Structure Sensor, Apple TrueDepth, and the LiDAR sensor in Apple's recent iPad Pro models. Build apps leveraging the power of spatial computing for millions of mobile devices.</p>
        <button @click="handleLogin">Sign Up/Login</button>
    </div>

    <div class="pricing-table">
        <h2>Pricing</h2>
        <div class="pricing-tier-container">
            <v-row>
                <v-col v-for="(tier, index) in pricingTiers" :key="index" cols="12" sm="6" md="3">
                    <v-card class="pricing-tier">
                        <h3 class="pricing-tier-title">{{ tier.title }}</h3>
                        <div class="pricing-tier-price">
                            <p v-html="tier.price"></p>
                            <p v-if="tier.billing">{{ tier.billing }}</p>
                        </div>
                        <div class="pricing-tier-features">
                            <p><strong>{{ tier.featuresTitle }}</strong></p>
                            <ul>
                                <li v-for="(feature, fIndex) in tier.features" :key="fIndex">{{ feature }}</li>
                            </ul>
                            <div v-if="tier.subFeatures">
                                <ul>
                                    <li v-for="(subFeature, sfIndex) in tier.subFeatures" :key="sfIndex">{{ subFeature }}</li>
                                </ul>
                            </div>
                            <p v-if="tier.note"><em>{{ tier.note }}</em></p>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>

    <div class="sdk-button-container">
        <a href="https://structure.io/structure-sdk" class="str-btn-secondary clear">Learn More About Structure SDK</a>
    </div>
</section>



</template>

<script>
import { useAuth0 } from "@auth0/auth0-vue";

export default {
  setup() {
    const { loginWithRedirect } = useAuth0();
    const logoImage = (image) => require(`@/assets/images/logos/${image}`);
    const homeImage = (image) => require(`@/assets/images/stock/${image}`);
    const rightArrow = () => require('@/assets/images/icons/arrow-right.svg');

    const handleLogin = () => {
      loginWithRedirect({
        appState: {
          target: "/console/getstarted",
        },
      });
    };

    const pricingTiers = [
      {
        title: 'Basic',
        price: '<strong>$149 per month</strong>',
        billing: 'Credit Card Only',
        featuresTitle: 'Basic Features:',
        features: [
          'Structure Sensor Scanning',
          '1 application',
          'Usage Reporting',
          'iOS Update Compatibility',
          'Anthropometrics',
        ],
        subFeatures: [
          'Landmark Detection',
          'Measurements',
        ],
      },
      {
        title: 'Professional',
        price: '<strong>$349 per month</strong>',
        billing: 'Credit Card Only',
        featuresTitle: 'Basic Features Plus:',
        features: [
          'Original Structure Sensor (ST01) Support',
          'Dedicated Account Management',
          'Dedicated Onboarding Support',
        ],
      },
      {
        title: 'Premium',
        price: '<strong>$499 per month</strong>',
        billing: 'Credit Card Only',
        featuresTitle: 'Professional Features Plus:',
        features: [
          'TrueDepth Scanning (Additional scanning fees apply for TD)',
          'SQI (Scan Quality Indicator)',
          'App Integration Support 1:1',
        ],
      },
      {
        title: 'Enterprise',
        price: '<strong>Contact Us</strong>',
        featuresTitle: 'All Features Plus:',
        features: [
          'More than 1 application',
          'OMS Capabilities',
          'Special SDK Implementation (AR/VR/etc.)',
          '510K clearance support',
          'Customer Troubleshoot Support',
        ],
        note: 'This plan supports a high user base.',
      },
    ];

    return {
      handleLogin,
      homeImage,
      logoImage,
      rightArrow,
      pricingTiers
    };
  },
};
</script>

<style scoped lang="scss">
    @import '@/assets/styles/HomeView.scss'
    @import '@/assets/styles/StrButtons.scss'
</style>